import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { useMemo } from 'react';

// Configure marked for clean output
marked.setOptions({
  breaks: true,     // line breaks → <br>
  gfm: true,        // GitHub Flavoured Markdown
});

interface MarkdownMessageProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Renders agent/AI messages as rich markdown with sanitized HTML.
 * Bold, italic, bullet lists, numbered lists, inline code, and links all work.
 */
export function MarkdownMessage({ content, className, style }: MarkdownMessageProps) {
  const html = useMemo(() => {
    const raw = marked.parse(content) as string;
    return DOMPurify.sanitize(raw, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'code', 'pre', 'a', 'blockquote', 'hr', 'h1', 'h2', 'h3', 'h4', 'span'],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    });
  }, [content]);

  return (
    <div
      className={`md-message${className ? ` ${className}` : ''}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
